import React, { useState, useEffect } from 'react';
import Crud_Catalogos from '../herramientas/Crud_Catalogos';
import { 
  List, Card, Grid, Avatar, Badge, 
  Dimmer, Button 
} from 'tabler-react';

const DetalleAlerta = ({ idAlerta, esquema }) => {
  const [detalleAlerta, setDetalleAlerta] = useState({});
  const [personaAtendio, setPersonaAtendio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Formatear fecha para mostrar en formato más legible
  const formatearFecha = (fechaString) => {
    if (!fechaString) return "No registrada";
    
    try {
      const fecha = new Date(fechaString);
      return fecha.toLocaleString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch (e) {
      return fechaString || "No registrada";
    }
  };

  // Obtener color según el estado de atención
  const getEstadoColor = () => {
    if (detalleAlerta.atendida === 1) return "success";
    return "danger";
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    // Determinar el endpoint correcto según el esquema
    if (esquema === "naviera") {
      crud("get", "", "", "navierasAlertas/" + idAlerta, "detalleAlerta"); 
    }
    if (esquema === "terrestre") {
      crud("get", "", "", "terrestresAlertas/id/" + idAlerta, "detalleAlerta"); 
    }
  }, [idAlerta, esquema]);

  const crud = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        switch (metodo) {
          case "get": 
            if (stateVar === "detalleAlerta") {
              if (returnVal) {
                setDetalleAlerta(returnVal);
                
                if (returnVal.atiendeUsuario !== null && returnVal.atiendeUsuario !== undefined) {
                  crud("get", "", "", "personas/" + returnVal.atiendeUsuario, "atiendeUsuario");
                } else {
                  setLoading(false);
                }
              } else {
                setLoading(false);
              }
            }
            
            if (stateVar === "atiendeUsuario") {
              if (returnVal) {
                setPersonaAtendio(returnVal);
              }
              setLoading(false);
            }
            break;
            
          default:
            setLoading(false);
            break;
        }
      })
      .catch(err => { 
        console.error("Error:", err);
        setError("Error al cargar los detalles de la alerta");
        setLoading(false);
      });
  };

  // Ver ubicación en el mapa
  const verEnMapa = () => {
    if (!detalleAlerta.latitud || !detalleAlerta.longitud) return;
    
    window.open(
      `https://maps.google.com/?q=${detalleAlerta.latitud},${detalleAlerta.longitud}&t=m`,
      "mapa_detalle_alerta",
      "width=900,height=600,scrollbars=NO"
    );
  };

  // Estado de carga
  if (loading) {
    return (
      <Dimmer active>
        <div className="loader"></div>
        <p className="text-center mt-3">Cargando detalles...</p>
      </Dimmer>
    );
  }

  // Estado de error
  if (error) {
    return (
      <Card className="p-4 text-center">
        <i className="fe fe-alert-triangle text-danger" style={{ fontSize: '3rem' }}></i>
        <h3 className="mt-3 text-danger">Error al cargar detalles</h3>
        <p>{error}</p>
        <Button color="primary" onClick={() => window.location.reload()}>
          Reintentar
        </Button>
      </Card>
    );
  }

  // Nombre completo del usuario que atendió
  const nombreCompletoAtendio = personaAtendio 
    ? `${personaAtendio.nombre || ''} ${personaAtendio.aPaterno || ''} ${personaAtendio.aMaterno || ''}`.trim()
    : "No registrado";

  return (
    <Card>
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <Avatar
              color={getEstadoColor()}
              icon="bell"
              className="mr-3"
            />
            <div>
              <h4 className="mb-0">Alerta #{detalleAlerta.id}</h4>
              <span className="text-muted">
                {detalleAlerta.triggerName || "Alerta del sistema"}
              </span>
            </div>
          </div>
          
          <Badge color={getEstadoColor()} className="px-3 py-1">
            {detalleAlerta.atendida === 1 ? "Atendida" : "Pendiente"}
          </Badge>
        </div>
      </Card.Header>
      
      <Card.Body>
        <Grid.Row>
          <Grid.Col width={6}>
            <Card>
              <Card.Header>
                <h5 className="m-0">
                  <i className="fe fe-info-circle mr-2 text-primary"></i>
                  Información general
                </h5>
              </Card.Header>
              <List.Group flush>
                <List.GroupItem action icon="credit-card">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>id:</span>
                    <strong>{detalleAlerta.id}</strong>
                  </div>
                </List.GroupItem>
                
                <List.GroupItem action icon="truck">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Movimiento:</span>
                    <strong>{detalleAlerta.idMovimiento}</strong>
                  </div>
                </List.GroupItem>
                
                <List.GroupItem action icon="pen-tool">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>trigger Name:</span>
                    <strong>{detalleAlerta.triggerName}</strong>
                  </div>
                </List.GroupItem>
                
                <List.GroupItem action icon="pen-tool">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>trigger Value:</span>
                    <span>{detalleAlerta.triggerValue || "N/A"}</span>
                  </div>
                </List.GroupItem>
              </List.Group>
            </Card>
          </Grid.Col>
          
          <Grid.Col width={6}>
            <Card>
              <Card.Header>
                <h5 className="m-0">
                  <i className="fe fe-clock mr-2 text-info"></i>
                  Estado y tiempos
                </h5>
              </Card.Header>
              <List.Group flush>
                <List.GroupItem action icon="calendar">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Fecha de creación:</span>
                    <strong>{detalleAlerta.fechaCreacion}</strong>
                  </div>
                </List.GroupItem>
                
                <List.GroupItem action icon="calendar">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Fecha atendido:</span>
                    <strong>{detalleAlerta.atiendeFecha || "No atendida"}</strong>
                  </div>
                </List.GroupItem>
                
                <List.GroupItem action icon="circle">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Atendido:</span>
                    <Badge color={getEstadoColor()}>
                      {detalleAlerta.atendida === 0 || detalleAlerta.atendida === null ? "No" : "Si"}
                    </Badge>
                  </div>
                </List.GroupItem>
                
                <List.GroupItem action icon="user-check">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Usuario:</span>
                    <span>{nombreCompletoAtendio}</span>
                  </div>
                </List.GroupItem>
              </List.Group>
            </Card>
          </Grid.Col>
        </Grid.Row>
        
        <Card className="mt-4">
          <Card.Header>
            <h5 className="m-0">
              <i className="fe fe-message-square mr-2 text-success"></i>
              Detalles
            </h5>
          </Card.Header>
          <Card.Body>
            <Grid.Row>
              <Grid.Col width={12}>
                <List.Group>
                  <List.GroupItem action icon="alert-circle">
                    <div className="form-group m-0">
                      <label className="form-label">Causa:</label>
                      <div className="form-control-plaintext">
                        {detalleAlerta.causa || "No especificada"}
                      </div>
                    </div>
                  </List.GroupItem>
                  
                  <List.GroupItem action icon="message-square">
                    <div className="form-group m-0">
                      <label className="form-label">Mensaje:</label>
                      <div className="form-control-plaintext">
                        {detalleAlerta.mensaje || "Sin mensaje"}
                      </div>
                    </div>
                  </List.GroupItem>
                </List.Group>
              </Grid.Col>
            </Grid.Row>
          </Card.Body>
        </Card>
        
        <Card className="mt-4">
          <Card.Header>
            <h5 className="m-0">
              <i className="fe fe-map-pin mr-2 text-danger"></i>
              Ubicación
            </h5>
          </Card.Header>
          <Card.Body>
            <Grid.Row>
              <Grid.Col width={6}>
                <List.GroupItem action icon="map-pin">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>latitud:</span>
                    <strong>{detalleAlerta.latitud || "No disponible"}</strong>
                  </div>
                </List.GroupItem>
              </Grid.Col>
              
              <Grid.Col width={6}>
                <List.GroupItem action icon="map-pin">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>longitud:</span>
                    <strong>{detalleAlerta.longitud || "No disponible"}</strong>
                  </div>
                </List.GroupItem>
              </Grid.Col>
              
              {(detalleAlerta.latitud && detalleAlerta.longitud) && (
                <Grid.Col width={12} className="text-center mt-3">
                  <Button 
                    color="success" 
                    icon="map"
                    onClick={verEnMapa}
                  >
                    Ver en Google Maps
                  </Button>
                </Grid.Col>
              )}
            </Grid.Row>
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  );
};

export default DetalleAlerta;